import { NgClass } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { forkJoin } from 'rxjs';
import { MetaDataService } from '../data-rules/meta-data.service';
import { RippleDirective } from '../ripple.directive';
import { MessageNotificationService } from '../shared/services/message-notification.service';
import { EnrichmentFieldMappingsComponent } from './field-mappings/enrichment-field-mappings.component';
import { EnrichmentFieldMappingsService } from './field-mappings/enrichment-field-mappings.service';
import { EnrichmentSourceFieldsComponent } from './source-fields/enrichment-source-fields.component';
import { EnrichmentSourceFieldsService } from './source-fields/enrichment-source-fields.service';

@Component({
  selector: 'app-enrichment-settings',
  imports: [
    NgClass,
    EnrichmentSourceFieldsComponent,
    EnrichmentFieldMappingsComponent,
    RippleDirective
  ],
  templateUrl: './enrichment-settings.component.html',
  styleUrls: ['./enrichment-settings.component.scss']
})
export class EnrichmentSettingsComponent implements OnInit {

  sourceFieldsNeedSaving = false;
  fieldMappingsNeedSaving = false;
  saving = false;
  candidateEntityLabel = 'Candidate';

  @ViewChild(EnrichmentSourceFieldsComponent)
  sourceFieldsComponent: EnrichmentSourceFieldsComponent;

  @ViewChild(EnrichmentFieldMappingsComponent)
  fieldMappingsComponent: EnrichmentFieldMappingsComponent;

  constructor(
    private enrichmentSourceFieldsService: EnrichmentSourceFieldsService,
    private enrichmentFieldMappingsService: EnrichmentFieldMappingsService,
    private messageNotificationService: MessageNotificationService,
    private metaDataService: MetaDataService
  ) {}

  ngOnInit(): void {
    this.metaDataService.getAllMeta().subscribe({
      next: () => {
        this.candidateEntityLabel = this.metaDataService.getEntitiesLabelsMap()['Candidate'] || 'Candidate';
      }
    });
  }

  needsSaving(): boolean {
    return this.sourceFieldsNeedSaving || this.fieldMappingsNeedSaving;
  }

  canSave(): boolean {
    return this.needsSaving() && (this.fieldMappingsComponent?.hasRequiredMappingsConfigured() ?? false);
  }

  updateSourceFieldsNeedSaving(event: boolean): void {
    this.sourceFieldsNeedSaving = event;
  }

  updateFieldMappingsNeedSaving(event: boolean): void {
    this.fieldMappingsNeedSaving = event;
  }

  save(): void {
    if (!this.fieldMappingsComponent.hasRequiredMappingsConfigured()) {
      this.messageNotificationService.error(
        'Validation Score and Enrichment Data Record ID must both be mapped before saving.'
      );
      return;
    }
    this.saving = true;
    forkJoin({
      sourceFields: this.enrichmentSourceFieldsService.saveSourceFields(this.sourceFieldsComponent.selectedFields),
      fieldMappings: this.enrichmentFieldMappingsService.saveFieldMappings(this.fieldMappingsComponent.mappings, this.fieldMappingsComponent.strategies)
    }).subscribe({
      next: () => {
        this.sourceFieldsNeedSaving = false;
        this.fieldMappingsNeedSaving = false;
        this.messageNotificationService.success('Enrichment settings saved.');
      },
      error: (err) => {
        console.error(err);
        this.messageNotificationService.error('Error saving enrichment settings.', err);
        this.saving = false;
      },
      complete: () => {
        this.saving = false;
      }
    });
  }
}
